import { render } from "./AboutTeamComp.vue?vue&type=template&id=ff379d1a&scoped=true"
import script from "./AboutTeamComp.vue?vue&type=script&lang=js"
export * from "./AboutTeamComp.vue?vue&type=script&lang=js"

import "./AboutTeamComp.vue?vue&type=style&index=0&id=ff379d1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff379d1a"]])

export default __exports__